import { IStatusDot } from '@ads/front-ds'
import {
  PaymentMethodResponse,
  ResponseAccountHistory,
} from '@ads/front-core/api'
import { lng } from '@ads/front-core/locales'
import { PaymentHistoryData } from '@ads/front-core/hooks/useFetchPaymentsHistory'

export type PaymentStatus = ResponseAccountHistory['list'][number]['status']

export type PaymentTypes = ResponseAccountHistory['list'][number]['type']

export const mapDataToDotColor = (
  type: PaymentTypes,
  status: PaymentStatus,
): IStatusDot['variant'] => {
  if (type === 'bonus') {
    return 'black'
  }

  switch (status) {
    case 'COMPLETED':
      return 'green'
    case 'CANCELED':
      return 'red'
    case 'FINALIZED':
      return 'green'
    default:
      return 'blue'
  }
}

export const mapDataToLabel = (item: PaymentHistoryData) => {
  if (item.type === 'bonus') {
    return lng(
      item.amountNet < 0 ? 'payments:bonusSettled' : 'payments:bonusGranted',
    )
  }

  switch (item.status) {
    case 'COMPLETED':
      return lng('payments:complete')
    case 'CANCELED':
      return lng('payments:paymentError')
    case 'FINALIZED':
      return lng('payments:refundCompleted')
    default:
      return lng('payments:inProgress')
  }
}

export const getPaymentMethodLabel = (
  type: ResponseAccountHistory['list'][number]['type'],
  paymentMethod: PaymentMethodResponse,
): string => {
  if (type === 'bonus') {
    return ''
  }
  switch (paymentMethod) {
    default:
    case 'MANUAL_PAYMENT':
      return lng('payments:paymentMethodPayU')
    case 'MANUAL_CARD':
      return lng('payments:paymentMethodManualCard')
    case 'AUTOMATIC_CARD':
      return lng('payments:paymentMethodAutomaticCard')
  }
}
